import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import useAgeGate from "../../../Hooks/useAgeGate";
import { useNavigate, useLocation } from "react-router-dom";
import { login, manualdownload, adminLogin } from "../../../Api/SubUrl";

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"));
}

export default function AgeGateCover() {
  const { verified, confirm } = useAgeGate();
  const dialogRef = useRef(null);
  const confirmBtnRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (verified) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [verified]);

  useEffect(() => {
    if (verified) return;

    const t = window.setTimeout(() => {
      confirmBtnRef.current?.focus?.();
    }, 0);

    const onKeyDown = (e) => {
      if (e.key !== "Tab") return;

      const focusables = getFocusableElements(dialogRef.current);
      if (focusables.length === 0) {
        e.preventDefault();
        return;
      }

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || active === dialogRef.current) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, [verified]);

  if (verified) return null;

  const onDecline = () => {};
  const onConfirm = () => {
    confirm();
    if (pathname !== manualdownload && pathname !== adminLogin) {
      navigate(login);
    }
  };

  return (
    <div className={styles.backdrop}>
      <div
        ref={dialogRef}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-label="Xác nhận độ tuổi"
        tabIndex={-1}
      >
        <h2 className={styles.title}>Xác nhận</h2>
        <p className={styles.content}>
          Bạn đủ <strong>18 tuổi trở lên</strong>?
          <br />
          Bạn cân nhắc tiếp tục?
        </p>
        <div className={styles.actions}>
          <button
            type="button"
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={onDecline}
          >
            Huỷ
          </button>
          <button
            ref={confirmBtnRef}
            type="button"
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={onConfirm}
          >
            Tiếp tục
          </button>
        </div>
      </div>
    </div>
  );
}
